<template>
  <v-card>
    <v-toolbar class="white--text" color="indigo" flat dense>
      <v-toolbar-title>Consuntivi di Produzione</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Vai alla Dashboard</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text style="max-height: 70vh; overflow-y: scroll">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="6" v-show="pezzi_allowed">
            <div @click="clickPezzi" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-animation-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    ><span class="primary--text" style="font-size: 20px"
                      >PEZZI</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="pezzi_insit_allowed">
            <div @click="clickPezziInsit" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col
                    ><span class="primary--text" style="font-size: 20px"
                      >PEZZI</span
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-animation-outline
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="tempi_allowed">
            <div @click="clickTempi" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-clipboard-text-clock-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      TEMPI
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="tempi_squadra_allowed">
            <div @click="clickTempiSquadra" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-clipboard-text-clock-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      TEMPI SQUADRA
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="scarti_allowed">
            <div @click="clickScarti" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-card-off-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      SCARTI
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="causali_allowed">
            <div @click="clickCausaliFermo" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-alert-octagon-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      FERMI
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="contenitori_allowed">
            <div @click="clickContenitori" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-package-variant-closed
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      CONTENITORI
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="autocontrolli_allowed">
            <div @click="clickAutocontrolli" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-clipboard-check-multiple-outline
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 18px"
                      >AUTOCONTROLLI</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="ordini_allowed">
            <div @click="clickOrdini" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-format-list-checks
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px"
                      >ORDINI</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
          <v-col cols="6" v-show="tracciabilita_allowed">
            <div @click="clickTracciabilita" class="consuntivi-card">
              <v-col>
                <v-row>
                  <v-col>
                    <v-icon size="60" color="primary">
                      mdi-format-list-numbered
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="primary--text" style="font-size: 20px">
                      TRACCIABILITÀ
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row justify="center" v-show="pezzi_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickPezzi" x-large>
            <span class="primary--text" style="font-size: 20px">Pezzi</span>
          </v-btn>
        </v-row>
        <v-row justify="center" v-show="pezzi_insit_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickPezziInsit" x-large>
            <span class="primary--text" style="font-size: 20px">Pezzi</span>
          </v-btn>
        </v-row>
        <v-row justify="center" v-show="tempi_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickTempi" x-large>
            <span class="primary--text" style="font-size: 20px">Tempi</span>
          </v-btn>
        </v-row> -->
        <!-- <v-row justify="center" v-show="scarti_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickScarti" x-large>
            <span class="primary--text" style="font-size: 20px">Scarti</span>
          </v-btn>
        </v-row> -->
        <!-- <v-row justify="center" v-show="causali_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickCausaliFermo" x-large>
            <span class="primary--text" style="font-size: 20px">Fermi</span>
          </v-btn>
        </v-row> -->
        <!-- <v-row justify="center" v-show="contenitori_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickContenitori" x-large>
            <span class="primary--text" style="font-size: 20px"
              >Contenitori</span
            >
          </v-btn>
        </v-row> -->
        <!-- <v-row justify="center" v-show="autocontrolli_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickAutocontrolli" x-large>
            <span class="primary--text" style="font-size: 20px"
              >Autocontrolli</span
            >
          </v-btn>
        </v-row> -->
        <!-- <v-row justify="center" v-show="ordini_allowed">
          <v-btn class="elevation-5 ma-5" @click="clickOrdini" x-large>
            <span class="primary--text" style="font-size: 20px">Ordini</span>
          </v-btn>
        </v-row> -->
      </v-col>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "Menu",
  components: {},
  props: {
    autocontrolli_allowed: { type: Boolean, default: true },
    causali_allowed: { type: Boolean, default: true },
    contenitori_allowed: { type: Boolean, default: true },
    ordini_allowed: { type: Boolean, default: true },
    pezzi_allowed: { type: Boolean, default: true },
    pezzi_insit_allowed: { type: Boolean, default: false },
    rotta_back: { type: String, default: "/home/production" },
    scarti_allowed: { type: Boolean, default: true },
    tempi_allowed: { type: Boolean, default: true },
    tempi_squadra_allowed: { type: Boolean, default: true },
    tracciabilita_allowed: { type: Boolean, default: true },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    gotoDashboard() {
      this.$router.push(this.rotta_back);
    },
    clickAutocontrolli() {
      this.$emit("click_autocontrolli");
    },
    clickContenitori() {
      this.$emit("click_contenitori");
    },
    clickPezzi() {
      this.$emit("click_pezzi");
    },
    clickPezziInsit() {
      this.$emit("click_pezzi_insit");
    },
    clickTempi() {
      this.$emit("click_tempi");
    },
    clickTempiSquadra() {
      this.$emit("click_tempi_squadra");
    },
    clickScarti() {
      this.$emit("click_scarti");
    },
    clickCausaliFermo() {
      this.$emit("click_causali_fermo");
    },
    clickOrdini() {
      this.$emit("click_ordini");
    },
    clickTracciabilita() {
      this.$emit("click_tracciabilita");
    },
  },
};
</script>
<style scoped>
.consuntivi-card {
  padding: 8px;
  height: 150px;
  background-color: rgba(244, 238, 238, 0.596);
  border-radius: 6px;
  -webkit-box-shadow: 0px 5px 14px -4px #8a8a8a;
  -moz-box-shadow: 0px 5px 14px -4px #8a8a8a;
  -o-box-shadow: 0px 5px 14px -4px #8a8a8a;
  box-shadow: 0px 5px 14px -4px #8a8a8a;
}

.consuntivi-card:hover {
  background-color: rgba(238, 228, 228, 0.596);
  -webkit-box-shadow: 0px 5px 14px -9px #8a8a8a;
  -moz-box-shadow: 0px 5px 14px -9px #8a8a8a;
  -o-box-shadow: 0px 5px 14px -9px #8a8a8a;
  box-shadow: 0px 5px 14px -9px #8a8a8a;
}
</style>
